import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { siteConfig } from '@/mocks/site';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-code-s-slash-line text-background-50 text-lg"></i>
              </span>
              <span className="text-xl font-bold text-background-50 font-heading">{siteConfig.name}</span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed mb-4">
              {siteConfig.description.slice(0, 60)}...
            </p>
            <div className="flex items-center gap-3">
              <a href={siteConfig.github} target="_blank" rel="noopener noreferrer" className="w-9 h-9 flex items-center justify-center rounded-md bg-background-800 hover:bg-primary-600 text-background-300 hover:text-background-50 transition-colors">
                <i className="ri-github-fill text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-md bg-background-800 hover:bg-primary-600 text-background-300 hover:text-background-50 transition-colors">
                <i className="ri-twitter-x-fill text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-md bg-background-800 hover:bg-primary-600 text-background-300 hover:text-background-50 transition-colors">
                <i className="ri-wechat-fill text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">技术分类</h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.slug}>
                  <Link to={`/category/${cat.slug}`} className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">快捷链接</h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">首页</Link></li>
              <li><Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">关于我们</Link></li>
              <li><a href="#" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">加入社区</a></li>
              <li><a href="#" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">内容合作</a></li>
              <li><a href="#" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">用户协议</a></li>
              <li><a href="#" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">隐私政策</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">联系我们</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line text-primary-400 mt-0.5"></i>
                <span className="text-sm text-background-400">{siteConfig.email}</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-github-fill text-primary-400 mt-0.5"></i>
                <a href={siteConfig.github} target="_blank" rel="noopener noreferrer" className="text-sm text-background-400 hover:text-primary-400 transition-colors">GitHub</a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-background-800">
        <div className="w-full px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; 2026 {siteConfig.name}. All rights reserved.
          </p>
          <p className="text-xs text-background-500">
            {siteConfig.beian}
          </p>
        </div>
      </div>
    </footer>
  );
}